import { createSlice } from "@reduxjs/toolkit";
import { addUser } from "../actions/adminUserManagement.action";

const initialState = {
  isLoading: false,
  data: null,
  error: null
};

const createNewUser = createSlice({
  name: "Create New User",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(addUser.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(addUser.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(addUser.rejected, (state,action) => {
      state.isLoading = false;
      state.error = action.error.message
    });
  },
});

export default createNewUser.reducer;
